import { Button } from '@/components/atoms';

interface RegistrationOptionCardProps {
	title: string;
	description: string;
	buttonText: string;
}

export const RegistrationOptionCard = ({ title, description, buttonText }: RegistrationOptionCardProps) => {
	return (
		<div className="w-full">
			<h2 className="mb-2 text-2xl font-medium leading-8 text-brand-800">{title}</h2>
			<p className="mb-6 text-base font-medium leading-6 text-gray-900">{description}</p>
			<Button className="mt-6 h-10 w-full bg-brand-800 text-sm hover:bg-brand-900 sm:w-60">{buttonText}</Button>
		</div>
	);
};
